








import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetDlyOvertimeStatistics} from "@/api/report"
import patDlyRecord from '../../../components/patDlyRecord.vue'

@Component({
	components: {patDlyRecord}
})
export default class AdjustPrice extends AbpBase {
	query = ""
	date: any = []
	data: any = []

	created() {
		const end = new Date();
		const start = new Date();
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
		this.date = [start, end]
		this.getData()
	}

	dateChange(e: any) {
		this.date = e
		this.getData()
	}

	options = {
		shortcuts: [
			{
				text: '一周',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
					return [start, end];
				}
			},
			{
				text: '一个月',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
					return [start, end];
				}
			},
			{
				text: '三个月',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
					return [start, end];
				}
			}
		]
	}
	columns = [
		{
			title: '值班人员',
			key: 'dutyNurse'
		},
		{
			title: '患者姓名',
			key: 'patientName'
		},
		{
			title: '部门',
			key: 'depart'
		},
		{
			title: '记录日期',
			key: 'inputDate',
			render: (h: any, params: any) => {
				return h('span',this.formatDate(params.row.inputDate))
			}
		},
		{
			title: '加班开始日期',
			key: 'startDate',
			render: (h: any, params: any) => {
				return h('span',this.formatDate(params.row.startDate))
			}
		},
		{
			title: '加班结束日期',
			key: 'endDate',
			render: (h: any, params: any) => {
				return h('span',this.formatDate(params.row.endDate))
			}
		},
		{
			title: '白班时长',
			key: 'dayDuration'
		},
		{
			title: '夜班时长',
			key: 'nightDuration'
		},
		{
			title: '审核状态',
			key: 'isAudit'
		},
		{
			title: '审核日期',
			key: 'auditDate',
			render: (h: any, params: any) => {
				return h('span', this.formatDate(params.row.auditDate))
			}
		},

	]

	async getData() {
		let res = await GetDlyOvertimeStatistics({
			QueryString: this.query,
			StartDate: this.date[0],
			EndDate: this.date[1]
		})
		this.data = res.objects
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/overtime1/index.vue